import * as React from 'react';
import styled from 'styled-components';
import { Text, Spacer } from '../parts';
import { Footer } from './parts/Footer';

export const CancelMembership: React.FC = () => {
	const handleEmailClick = () => {
		const subject = encodeURIComponent('Cancel My Live Rewards Membership');
		const body = encodeURIComponent(
			'Hello,\n\nI would like to cancel my Live Rewards membership.\n\nPlease include:\n- Your email address associated with your account\n- Your full name\n- Reason for cancellation (optional)\n\nThank you,\n'
		);
		window.location.href = `mailto:support@liverewardsgo.com?subject=${subject}&body=${body}`;
	};

	return (
		<PageBody>
			<Container>
				<Spacer size={60} />
				<Text weight="black" size={50} center>
					Cancel Your Membership
				</Text>
				<Spacer size={40} />

				<ContentSection>
					<Text color="#3d3d3d" size={16} center>
						We're sorry to see you go! To cancel your Live Rewards membership, please send us an email with your request.
					</Text>
				</ContentSection>

				<Spacer size={60} />

				<CancellationBox>
					<Text weight="semi-bold" size={24}>
						How to Cancel
					</Text>
					<Spacer size={20} />
					<Text color="#3d3d3d" size={16}>
						Send an email to <strong>support@liverewardsgo.com</strong> with the following information:
					</Text>
					<Spacer size={20} />
					<InfoList>
						<InfoItem>
							<Text weight="bold" size={16}>
								• Your email address
							</Text>
							<Text color="#666" size={14}>
								The email address associated with your Live Rewards account
							</Text>
						</InfoItem>
						<Spacer size={15} />
						<InfoItem>
							<Text weight="bold" size={16}>
								• Your full name
							</Text>
							<Text color="#666" size={14}>
								As it appears on your account
							</Text>
						</InfoItem>
						<Spacer size={15} />
						<InfoItem>
							<Text weight="bold" size={16}>
								• Reason for cancellation (optional)
							</Text>
							<Text color="#666" size={14}>
								Help us improve by letting us know why you're cancelling
							</Text>
						</InfoItem>
					</InfoList>
					<Spacer size={30} />
					<EmailButton onClick={handleEmailClick}>Send Cancellation Email</EmailButton>
				</CancellationBox>

				<Spacer size={80} />

				<ContentSection>
					<InfoBox>
						<Text weight="bold" size={20}>
							Before You Go...
						</Text>
						<Spacer size={15} />
						<Text color="#3d3d3d" size={16}>
							<strong>• Your membership will be cancelled immediately</strong>
							<br />
							You will lose access to all exclusive discounts and deals.
							<br />
							<br />
							<strong>• Refunds</strong>
							<br />
							If you cancel within 14 days of signing up, you may be eligible for a refund. Please contact our support team.
							<br />
							<br />
							<strong>• Reactivation</strong>
							<br />
							You can reactivate your membership at any time by downloading the app again.
							<br />
							<br />
							<strong>• Need Help?</strong>
							<br />
							Contact our support team at support@liverewardsgo.com or call 1-800-REWARDS
						</Text>
					</InfoBox>
				</ContentSection>

				<Spacer size={60} />

				<ContentSection>
					<Text weight="semi-bold" size={20} center>
						Have Questions?
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16} center>
						Before cancelling, you might want to reach out to our support team. We're here to help!
						<br />
						<br />
						<strong>Email:</strong> support@liverewardsgo.com
						<br />
						<strong>Phone:</strong> 1-800-REWARDS
						<br />
						<strong>Hours:</strong> Monday - Friday, 9am - 5pm PST
					</Text>
				</ContentSection>

				<Spacer size={100} />
			</Container>
			<Footer />
		</PageBody>
	);
};

const PageBody = styled.div``;

const Container = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0px 20px;

	@media only screen and (max-width: 1200px) {
		padding: 0px 20px;
	}
`;

const ContentSection = styled.div`
	max-width: 800px;
	width: 100%;
`;

const CancellationBox = styled.div`
	max-width: 700px;
	width: 100%;
	padding: 40px;
	background-color: #f9f9f9;
	border-radius: 12px;
	border: 2px solid #e0e0e0;
`;

const InfoList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px;
`;

const InfoItem = styled.div`
	padding: 15px;
	background-color: white;
	border-left: 4px solid #165a63;
	border-radius: 4px;
`;

const EmailButton = styled.button`
	background-color: #165a63;
	color: white;
	padding: 14px 40px;
	border: none;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	transition: background-color 0.2s ease;
	width: 100%;

	&:hover {
		background-color: #0d2b2f;
	}

	&:active {
		transform: scale(0.98);
	}
`;

const InfoBox = styled.div`
	padding: 30px;
	background-color: #fff3cd;
	border-left: 4px solid #ffc107;
	border-radius: 8px;
`;
